import '../static/LogoGrid.css';
import React__default from "react";
import { a as Grid } from "./Grid.QyNjlydO.mjs";
import { C as Col } from "./Col.COJSUXXS.mjs";
import { a as SectionWrap } from "./SectionWrap.DExzuSui.mjs";
import { b as SectionHeader } from "./SectionHeader.VCo9GnTI.mjs";
import { a as Logo } from "./Logo.5_HKhQuM.mjs";
const list = `_list_7767812`;
const logo = `_logo_50d05a2`;
const imageWrapper = `_imageWrapper_e6102af`;
const styles = { list, logo, imageWrapper };
const LogoGrid = ({
  className,
  sectionHeader,
  logoList,
  logoSize = "lg",
  ...props
}) => {
  return /* @__PURE__ */ React__default.createElement(SectionWrap, { className, "data-ui-logo-grid": true, ...props }, sectionHeader && /* @__PURE__ */ React__default.createElement(SectionHeader, { ...sectionHeader, "data-testid": "header" }), /* @__PURE__ */ React__default.createElement(Grid, { className: styles.list, xAlign: "center", "data-testid": "logo-list" }, logoList.map((img, i) => /* @__PURE__ */ React__default.createElement(
    Col,
    {
      sm: 2,
      md: 2,
      lg: 2,
      key: i,
      className: styles.imageWrapper,
      as: "figure"
    },
    /* @__PURE__ */ React__default.createElement(
      Logo,
      {
        ...img,
        key: img.url,
        className: styles.logo,
        autoWidth: false,
        size: logoSize
      }
    )
  ))));
};
export {
  LogoGrid as L
};
//# sourceMappingURL=LogoGrid.CA4LyvpX.mjs.map
